export function loadMomentList(willReload) {
  return {
    type: 'LOAD_MOMENT_LIST',
    willReload,
  }
}

export function loadMomentListCompletion(error, data) {
  return {
    type: 'LOAD_MOMENT_LIST_COMPLETION',
    error,
    data,
  }
}

export function loadMomentDetail(id) {
  return {
    type: 'LOAD_MOMENT_DETAIL',
    id,
  }
}

export function loadMomentDetailCompletion(error, data) {
  return {
    type: 'LOAD_MOMENT_DETAIL_COMPLETION',
    error,
    data,
  }
}

export function saveMomentShareRecord(id) {
  return {
    type: 'SAVE_MOMENT_SHARE_RECORD',
    id,
  }
}

export function likeMoment(id) {
  return {
    type: 'LIKE_MOMENT',
    id,
  }
}

export function likeMomentCompletion(error, data) {
  return {
    type: 'LIKE_MOMENT_COMPLETION',
    error,
    data,
  }
}

export function deleteMoment(id) {
  return {
    type: 'DELETE_MOMENT',
    id,
  }
}

export function deleteMomentCompletion(error, data) {
  return {
    type: 'DELETE_MOMENT_COMPLETION',
    error,
    data,
  }
}

export function writeMoment(content, imageVos) {
  return {
    type: 'WRITE_MOMENT',
    content,
    imageVos,
  }
}

export function writeMomentCompeltion(error) {
  return {
    type: 'WRITE_MOMENT_COMPLETION',
    error,
  }
}

export function loadMomentHistory(willReload, uid) {
  return {
    type: 'LOAD_MOMENT_HISTORY',
    willReload,
    uid,
  }
}

export function loadMomentHistoryCompletion(error, data) {
  return {
    type: 'LOAD_MOMENT_HISTORY_COMPLETION',
    error,
    data,
  }
}

export function loadMomentMessage(willReload) {
  return {
    type: 'LOAD_MOMENT_MESSAGE',
    willReload,
  }
}

export function loadMomentMessageCompletion(error, data) {
  return {
    type: 'LOAD_MOMENT_MESSAGE_COMPELTION',
    error,
    data,
  }
}

export function readMomentMessage(id) {
  return {
    type: 'READ_MOMENT_MESSAGE',
    id,
  }
}

export function readMomentMessageCompletion(error, id) {
  return {
    type: 'READ_MOMENT_MESSAGE_COMPLETION',
    error,
    id,
  }
}

export function loadMomentMessageUnread() {
  return {
    type: 'LOAD_MOMENT_MESSAGE_UNREAD',
  }
}

export function loadMomentMessageUnreadCompletion(error, data) {
  return {
    type: 'LOAD_MOMENT_MESSAGE_UNREAD_COMPLETION',
    error,
    data,
  }
}
